import keys from "lodash/keys";

//
// Action types
//

export const UPDATE_FORM_ERRORS = "UPDATE_FORM_ERRORS";
export const UPDATE_FIELD_ERRORS = "UPDATE_FIELD_ERRORS";
export const UPDATE_FIELD_ERRORS_DISPLAY = "UPDATE_FIELD_ERRORS_DISPLAY";

//
// Action creators
//

export function updateFormErrors(formKey, errors) {
  return {
    type: UPDATE_FORM_ERRORS,
    formKey,
    errors
  };
}

export function updateFieldErrors(formKey, fieldName, errors) {
  return {
    type: UPDATE_FIELD_ERRORS,
    formKey,
    fieldName,
    errors
  };
}

export function updateFieldErrorsDisplay(formKey, fieldName, show) {
  return {
    type: UPDATE_FIELD_ERRORS_DISPLAY,
    formKey,
    fieldName,
    show
  };
}

//
// Reducer and handlers
//

function updateFormErrorsHandler(state, errors) {
  return keys(errors).reduce((newState, fieldName) => {
    return updateFieldErrorsHandler(newState, fieldName, {
      errors: errors[fieldName],
      show: true
    });
  }, {});
}

function updateFieldErrorsHandler(state, fieldName, data) {
  // Ensure that we have a
  if (!state[fieldName]) {
    state[fieldName] = {};
  }

  const errorsData = {
    ...state[fieldName],
    ...data
  };

  return { ...state, [fieldName]: errorsData };
}

export function reduceErrors(state = {}, action) {
  switch (action && action.type) {
    case UPDATE_FORM_ERRORS:
      return updateFormErrorsHandler(state, action.errors);

    case UPDATE_FIELD_ERRORS:
      return updateFieldErrorsHandler(state, action.fieldName, {
        errors: action.errors
      });

    case UPDATE_FIELD_ERRORS_DISPLAY:
      return updateFieldErrorsHandler(state, action.fieldName, {
        show: action.show
      });

    default:
      return state || {};
  }
}
